import _ from 'lodash';
import {isAsyncFunction} from './asyncDecorator';
import mixin from './mixin';
import GhostClasses from '../../ui/mixins/GhostClasses';

const getAllPropertyNamesRecursively = (obj, propNames) => {
    _.forEach(Object.getOwnPropertyNames(obj), (name) => propNames.add(name));

    const prototype = Object.getPrototypeOf(obj);
    if (prototype && Object.getPrototypeOf(prototype)) {
        getAllPropertyNamesRecursively(Object.getPrototypeOf(obj), propNames);
    }
    return Array.from(propNames);
};

const getAllPropertyNames = (obj) => {
    const propNames = new Set();
    return getAllPropertyNamesRecursively(obj, propNames);
};

export default function (receiver) {
    const receiverPropNames = getAllPropertyNames(receiver);

    _(receiverPropNames)
        .filter(isAsyncFunction)
        .forEach((prop) => Object.defineProperty(
            receiver,
            prop,
            {
                value: () => Promise.resolve(),
                configurable: true
            }
        ));

    const GhostClazz = GhostClasses[`${receiver.constructor.name}Ghost`];
    return GhostClazz ? mixin(receiver, GhostClazz.prototype) : receiver;
}
